import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ad0d4aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-list" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filter-list-close__icon" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filter-list-close__text" }, " Закрыть ", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filter-list-rollup__icon" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filter-list-rollup__text" }, " Свернуть ", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Item = _resolveComponent("Item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['filter-items', `filter-items--${_ctx.filterType}`])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtersByColumns, (columnFilters, columnIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          key: columnFilters,
          class: "filter-items__column"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columnFilters, (filter, filterIndex) => {
            return (_openBlock(), _createBlock(_component_Item, {
              key: filter.id,
              item: filter,
              class: _normalizeClass({
            'filter-item--lst-column-frst-lst-item':
              (columnIndex === _ctx.filtersByColumns.length - 1) &&
              ((filterIndex === 0) || filterIndex === columnFilters.length - 1)
          }),
              "is-selected": _ctx.isSelectedItem(filter),
              onClick: ($event: any) => (_ctx.$emit('select', filter.id))
            }, null, 8, ["item", "class", "is-selected", "onClick"]))
          }), 128))
        ]))
      }), 128))
    ], 2),
    _createElementVNode("div", {
      class: "filter-list-close",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
    }, _hoisted_4),
    _createElementVNode("div", {
      class: "filter-list-rollup",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
    }, _hoisted_7)
  ]))
}